export default __webpack_public_path__ + "static/media/raya-promo.e534705f.webp";